import React from "react";
import WhyChooseAptech from "../../components/AboutUs/WhyChoose/WhyChooseAptech.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";

const WhyChooseAptechPage: React.FC = () => {
  return (
    <div>
            <MetaComponent
        title="Why Choose Aptech | Aptech Limited"
        desc="Aptech is a global leader in skill-based education for students and professionals. It has expanded into sectors like IT training, media entertainment, retail, aviation, beauty and wellness, pre-school education."
        keywords="vocational training business, vocational training, Aptech limited, vocational training institute"
      />
      <WhyChooseAptech />
    </div>
  );
}

export default WhyChooseAptechPage;

